export enum TelephonyStatEnum {
  Answered = 1,
  Missed = 2,
}
